import React from 'react';
export type FormType = 'EDIT' | 'SHOW' | 'CREATE' | 'NONE';
const formTypeContext = React.createContext<FormType>('NONE');
export default formTypeContext;
